// extracted by mini-css-extract-plugin
export default {"addUser":"ProductInfosPopup_addUser__xJXCx","user":"ProductInfosPopup_user__yPuXb","users":"ProductInfosPopup_users__7Py2l","select":"ProductInfosPopup_select__LXHB0"};